import type { AppConfig } from '@quipex/core/config';

export function extractFileExtension(filename: string): string {
    const re = /(?:\.([^.]+))?$/;
    const ext = re.exec(filename)?.[1] ?? '';
    return ext;
}

export function extractFileNameWithoutExtension(filename: string): string {
    const lastDotPosition = filename.lastIndexOf('.');
    if (lastDotPosition === -1) return filename;
    else return filename.substring(0, lastDotPosition);
}

export function checkFileUploadType(
    fileName: string,
    appConfig: AppConfig
): boolean {
    const ext = extractFileExtension(fileName.toLowerCase());

    if (!ext) return false;

    return appConfig.documentUploadTypes
        .map((t) => t.trim().toLowerCase().replace(/^\./, ''))
        .includes(ext);
}

/**
 * Extract the base64 string out of a File using FileReader Class
 * @param file File object
 * @returns a Promise
 */
export function getBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = () => {
            return reject(reader.error ?? new Error('FileReader error'));
        };
    });
}

/**
 * Parses a base64 string with header information and returns the raw string value
 * @param base64String
 * @returns base64 string without header information
 */
export function getBase64StringRaw(base64String: string): string {
    return base64String.substring(base64String.lastIndexOf(',') + 1);
}
